/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 3.04.21
 *
 */
require("./page")

let {setSpecialReferrerIfNeeded} = require("./core/referrer/referrer")
let Cookies = require('js-cookie')

setSpecialReferrerIfNeeded()
if(window.analyticsManager){
    let params = analyticsManager.getPageViewProps()
    analyticsManager.trackEvent("Website visit", params)
}

//if cookie qw_sa is set, hide free plan and show tools plan using vanilla js
function showToolsPlanIfNeeded(){
    let cookie = Cookies.get("qw_sa")
    console.log("showToolsPlanIfNeeded: cookie = ", cookie)
    if(cookie){
        let freePlan = document.getElementById("plan_free")
        let toolsPlan = document.getElementById("plan_tools")
        freePlan.style.display = "none"
        toolsPlan.style.display = "block"
    }
}
showToolsPlanIfNeeded()

// let {referrerRedirect} = require("./core/referrer/referrer")
//
// referrerRedirect()
